import { render, staticRenderFns } from "./briefIntroduction.vue?vue&type=template&id=5a744822&scoped=true&"
import script from "./briefIntroduction.vue?vue&type=script&lang=js&"
export * from "./briefIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./briefIntroduction.vue?vue&type=style&index=0&id=5a744822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a744822",
  null
  
)

export default component.exports